export interface AgregarPersonaStep {
  value: number;
  label: string;
}

export const AGREGAR_PERSONA_STEPS: AgregarPersonaStep[] = [
  { value: 1, label: 'Datos básicos' },
  { value: 2, label: 'Información adicional' },
  { value: 3, label: 'Contacto' },
];

/** Step 2 solo para admin en alta; en editar nunca se muestra. */
export function resolveAgregarPersonaSteps(options: {
  isAdmin: boolean;
  isEdit: boolean;
}): AgregarPersonaStep[] {
  if (options.isEdit || !options.isAdmin) {
    return AGREGAR_PERSONA_STEPS.filter((step) => step.value !== 2);
  }
  return AGREGAR_PERSONA_STEPS;
}

export function nextAgregarPersonaStep(
  current: number,
  steps: AgregarPersonaStep[],
): number {
  const values = steps.map((step) => step.value);
  const idx = values.indexOf(current);
  if (idx < 0 || idx >= values.length - 1) {
    return current;
  }
  return values[idx + 1];
}

export function prevAgregarPersonaStep(
  current: number,
  steps: AgregarPersonaStep[],
): number {
  const values = steps.map((step) => step.value);
  const idx = values.indexOf(current);
  if (idx <= 0) {
    return current;
  }
  return values[idx - 1];
}